import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Span } from '../../../../Styles/CommonStyles';
import styled from 'styled-components';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Box, Chip, Typography } from "@mui/material";
import UnivMyAssetComp from '../../Myasset/UnivMyAssetComp';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />; 

const AllStoreAssetsTableCont = styled.div``
const SelectTagsContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`
const AssetSelectWrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  width:50%;    
`

const columnFilter = [ "OEM/ORG Tag", "OEM/Brand", "Purchase Date", "Detail", "Specification", "Model"]


const SelectAssetsModal = ({handleSelectAssetsModalClose, selectassetmodalopen, selectedOptions, setSelectedOptions, filterProps}) => {
  console.log(filterProps)
  return (
    <React.Fragment>
      <Dialog
        onClose={handleSelectAssetsModalClose}
        aria-labelledby="customized-dialog-title"
        open={selectassetmodalopen}
        maxWidth="xl"
      >
        <DialogTitle>
          <Span>Select Requisite Assets</Span>
        </DialogTitle>
        <DialogContent dividers>
          <AllStoreAssetsTableCont>
            <SelectTagsContainer>
              <AssetSelectWrapper>
              <Typography variant="subtitle1" gutterBottom>
                Selected Assets:
              </Typography>
                <Box
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: "8px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    marginLeft: "15px",
                    minHeight: "20px",
                    minWidth:"200px"
                  }}
                >
                  {selectedOptions.map((tag, index) => (
                    <Chip
                      key={index}
                      label={tag.oem_tag}
                      variant="outlined"
                      sx={{backgroundColor: "#f0f0f0"}}
                    />
                  ))}
                </Box>                
              </AssetSelectWrapper>
            </SelectTagsContainer>
            <UnivMyAssetComp
              columnFilter={columnFilter}
              checkbox={true}
              selectAll={false}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              filterProps={filterProps}
            />
          </AllStoreAssetsTableCont>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSelectAssetsModalClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export default SelectAssetsModal